
import { computed, defineComponent, reactive } from 'vue';
import { IOptionString } from '@/core/models/AntDesign/IOption';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoMovimentoFinanceiro from '@/servicos/Financeiro/ServicoMovimentoFinanceiro';
import storeSistema from '@/store/storeSistema';

export default defineComponent({
  name: 'SelecionarMarcadorMovimentoFinanceiro',
  props: {
    marcadoresSelecionados: {
      type: Array as () => string[],
      default: () => [],
    },
    empresas: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Digite para definir um marcador',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:marcadoresSelecionados'],
  setup(props, { emit }) {
    let debounce = 0;
    const servicoMovimentoFinanceiro = new ServicoMovimentoFinanceiro();

    const state = reactive({
      empresas: [] as number[],
      listaMarcadores: [] as IOptionString[],
    });

    const computedMarcadoresSelecionados = computed({
      get: () => props.marcadoresSelecionados,
      set: (valor: string[]) => {
        emit('update:marcadoresSelecionados', valor);
      },
    });

    async function pesquisarMarcador(valorPesquisa: any) {
      state.listaMarcadores = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        if (UtilitarioGeral.validaLista(props.empresas)) {
          state.empresas = props.empresas;
        } else {
          state.empresas = storeSistema.getters.empresasUsuarioAutenticado();
        }

        const marcadoresApi = await servicoMovimentoFinanceiro.consultarMarcadores(state.empresas, valorPesquisa);
        marcadoresApi.forEach((marcador) => {
          const optionMarcador:IOptionString = { value: marcador, label: marcador };
          state.listaMarcadores.push(optionMarcador);
        });
      }, 600);
    }

    return {
      props,
      state,
      pesquisarMarcador,
      computedMarcadoresSelecionados,
    };
  },
});
